import { CButton, CModal, CModalBody, CModalFooter, CModalHeader, CModalTitle } from '@coreui/react'
import React from 'react'

const CustomModal = ({ show = false, setShow, title, description = "", component, classNames = "", size = 'lg',
  confirmButtonText = "", cancelButtonText = "", confirmAction = () => { }, footerComponent, backdrop = false }) => {
  return (
    <CModal visible={show} onClose={() => setShow(false)} className={classNames}
      backdrop={backdrop ? "static" : true}
      keyboard={backdrop}
      size={size}>
      <CModalHeader onClose={() => setShow(false)}>
        <CModalTitle>{typeof title === 'string' ? title : typeof title === 'function' ? title() : '---'}</CModalTitle>
      </CModalHeader>
      <CModalBody>{component ? component() : description}</CModalBody>
      <CModalFooter>
        {!footerComponent ?
          <>
            <CButton color="secondary" onClick={() => setShow(false)}>
              {cancelButtonText}
            </CButton>
            {confirmButtonText && <CButton color="primary" onClick={confirmAction}>{confirmButtonText}</CButton>}</> : footerComponent({ setShow })}
      </CModalFooter>
    </CModal>
  )
}

export default CustomModal